import { ButtonHTMLAttributes } from 'react';
import { styled, Typography } from '@mui/material';
import { motion } from 'framer-motion';

import PublishedDate from '@/components/PublishedDate';
import { DeleteIcon } from '@/components/icons';

export const CommentContainer = styled(motion.div)`
  // border: 1px solid red;

  // border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  // background-color: ${({ theme }) => theme.palette.grey[100]};
  // padding: ${({ theme }) => theme.spacing(2, 4)};
  // ${({ theme }) => theme.breakpoints.up('sm')} {
  //   padding: ${({ theme }) => theme.spacing(5, 8)};
  // }
`;

export const Header = styled('div')`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const CommenterName = styled('span')`
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
`;

export const OptionsWrapper = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  column-gap: 0.2rem;
`;

export const CommentDate = styled(PublishedDate)`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  color: ${({ theme }) => theme.palette.grey[200]};
`;
export const CommentBody = styled(Typography)`
  line-height: 26px;
  word-break: break-word;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: ${({ theme }) => theme.spacing(4.5)};
  }
`;

export const ActionsSection = styled('div')`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const OptionButton = styled('button')`
  vertical-align: middle;
`;

export const DeleteButton = (
  props: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'css'>,
): JSX.Element => {
  return (
    <OptionButton
      title="Delete comment"
      aria-label="Delete comment"
      onClick={props.onClick}
      {...props}
    >
      <DeleteIcon width="1.5rem" height="1.5rem" />
    </OptionButton>
  );
};
